// Objet donées de transfert.
// Utile pour ajouter l'adresse mailà un user Azure via son homeId

export class UserEmailAzureDTO {
  mail: string;
  azureId: string;
}

export class UserPhoneAzureDTO {
  phone: string;
  azureId: string;
}
